import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "sw-lightsaber-obiwan-ep4-motorized-stunt",
  name: `Motorized Lightsaber\nObi-Wan Kenobi Ep4`,
  nameFormatted: {
    primary: "Motorized Lightsaber",
    secondary: "Obi-Wan Kenobi Ep4",
  },
  origin: "Star Wars: Episode IV A New Hope",

  category: replicaCategories.starWars,

  versions: [Version1],
};

export default data;
